export default {
  custom_additive: {
    placeholder: 'Agregar opción personalizada',
  },
  buttons: {
    add: 'Agregar',
  },
};
